import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FlightDeckClient } from '@atlassiansox/flight-deck-frontend-client';
import BundledArtifact from './default-data/recent-work-service-artifact';
const RECENT_WORK_ARTIFACT = 'recent-work-service';
const FD_ENVIRONMENT = 'prod';
export const FD_CLIENT_FETCH_PROPS = {
  name: RECENT_WORK_ARTIFACT,
  dimensions: {
    environmentType: FD_ENVIRONMENT
  }
};
export default class HydratorConfigClient {
  constructor(handlers, product, artifactFetch) {
    _defineProperty(this, "fetchConfig", async () => {
      const artifact = await this.fetchArtifact();
      const {
        queryFragments: fragments,
        hydrators
      } = artifact;
      return {
        fragments,
        hydrators
      };
    });
    this.flightDeck = new FlightDeckClient(product || 'recent-work-client', {
      handlers
    }, [{
      name: 'recent-work-service',
      dimensions: {
        environmentType: FD_ENVIRONMENT
      },
      value: BundledArtifact
    }]);
    this.artifactFetch = artifactFetch;
  }
  async fetchArtifact() {
    if (this.artifactFetch) {
      return this.artifactFetch();
    }
    return this.flightDeck.fetchConfigFromFlightDeck(FD_CLIENT_FETCH_PROPS,
    // Retries are for the background refresh, so not too aggressive
    {
      intervalsMS: [100, 500]
    });
  }
}